import React from 'react';
import { Icon } from '@placer-ui/components';
import { SHARED_WITH_USERS, SHARED_WITH_ACCOUNT } from '../../consts';
import { XtraTableRow } from '../xtra-requests-table/xtra-requests-table-config';
import { OrderManagementRequest } from 'core/entities';
import { getPermissions } from 'core/flow-control';
import { formatPoiData } from 'features/offline-reports/order-management/order-management';

export const xtraRequestsSharedIconData = (sharedWith: string[], target: string) => {
    if (target === 'account') {
        return <Icon type={'Buildings'} size={16} />;
    } else if (sharedWith.length > 0) {
        return <Icon type={'Users'} size={16} />;
    } else {
        return <div> -- </div>;
    }
};

export const getSharedWithDataTooltip = (data?: XtraTableRow) => {
    const sharedWith = data?.sharedWithData?.tooltipData;
    const sharedWithUsersId = data?.sharedWithData?.sharedWithUsersId;

    if (!sharedWithUsersId || sharedWithUsersId.length === 0 || !sharedWith) return null;

    return (
        <div>
            <div>{sharedWithUsersId[0] !== '' ? SHARED_WITH_USERS : SHARED_WITH_ACCOUNT}</div>
            {sharedWithUsersId.map((sharedId) => (
                <div key={`shared_user_${sharedId}`}>{sharedWith[sharedId]}</div>
            ))}
        </div>
    );
};

export const getSharedMenuItem = (
    record: OrderManagementRequest,
    onShareClick: (request: OrderManagementRequest) => void,
) => {
    const { zipFile, mapsLink, tablouLink, status, sharedBy } = record;
    const { enable_xtra_reports_sharing } = getPermissions();

    if (
        enable_xtra_reports_sharing &&
        ['solved', 'closed'].includes(status) &&
        !sharedBy &&
        (zipFile || mapsLink || tablouLink)
    ) {
        return [
            {
                value: 'Share',
                label: 'Share',
                testId: 'xtra-reports-share-request',
                onClick: () => onShareClick(record),
            },
        ];
    }
    return [];
};

export const getShareMenuOptions = (accountName: string, isAccountShared: boolean) => {
    return [
        {
            label: 'Specific Users',
            value: 'user',
            testId: 'specific-users-sharing-option',
            LeftComponent: <Icon type={'Users'} size={16} />,
            isSelected: !isAccountShared,
        },
        {
            label: `${accountName}`,
            value: 'account',
            testId: 'account-name-sharing-option',
            LeftComponent: <Icon type={'Buildings'} size={16} />,
            isSelected: isAccountShared,
        },
    ];
};

export const getRequestSubject = (xtraRequest: OrderManagementRequest) => {
    const { entities, poiDataList } = xtraRequest;
    const entityCount = entities.filter((entity) => entity.name !== null).length;
    const firstEntity = entities[0];

    let poiDataComponent: { numOfEntities: number } = {
        numOfEntities: 0,
    };

    if (poiDataList && poiDataList?.trim().length > 0) {
        poiDataComponent = formatPoiData(poiDataList);
    }

    const { numOfEntities } = poiDataComponent;

    if (!numOfEntities) {
        if (entityCount > 1) {
            return `${entityCount} Locations`;
        }
    } else {
        if (numOfEntities > 1) {
            return `${numOfEntities} Locations`;
        }
    }
    if (!firstEntity.name) {
        return '';
    }
    return `${firstEntity.name} - ${firstEntity.address}`;
};
